<template>
    <div
        class="h-screen w-screen bg-gray-200 justify-center content-center flex flex-wrap"
    >
        <div class="container">
            <h1 class="text-2xl text-red-600 font-bold">
                Welcome to the super secret text reminder app dashboard
            </h1>
            <Link href="/logout" method="POST">
                <p
                    class="text-sm text-gray-700 hover:underline w-full cursor-pointer"
                >
                    log me out, scottie
                </p>
            </Link>
            <div class="mt-4 p-8 bg-white lg:w-1/2 w-full rounded shadow-xl">
                <message-form></message-form>
            </div>
        </div>
    </div>
</template>

<script>
import MessageForm from "../../components/MessageForm";

export default {
    components: { MessageForm },
    name: "Index",
    props: ["name"]
};
</script>

<style scoped></style>
